import { render, staticRenderFns } from "./allScenicAreaPeopleFlow.vue?vue&type=template&id=482643a8&scoped=true"
import script from "./allScenicAreaPeopleFlow.vue?vue&type=script&lang=js"
export * from "./allScenicAreaPeopleFlow.vue?vue&type=script&lang=js"
import style0 from "./allScenicAreaPeopleFlow.vue?vue&type=style&index=0&id=482643a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482643a8",
  null
  
)

export default component.exports